export default function({ dispatch, commit }, params) {
    // POST /auth/change/email
    return dispatch('post', {
        url: '/auth/change/email',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        return error
    })
}
